'use strict';

const applyMatchHeight = (elements, options, context) => {
  const collection = typeof elements === 'string'
    ? $(context).find(elements)
    : $(elements);

  if (typeof $.fn.matchHeight !== 'function') {
    console.warn('jquery-match-height is not available.');
    return collection;
  }

  if (!collection.length) {
    console.warn('matchHeight did not find any elements:', elements);
    return collection;
  }

  if (collection.length === 1 && !options.target) {
    console.warn('matchHeight requires at least two elements unless target is set:', elements);
  }

  return collection.matchHeight(options);
};

/**
 * Apply jquery-match-height to one collection or a list of group definitions.
 *
 * A group definition has the following shape:
 * { elements: '.selector', options: { byRow: true }, context: document }
 *
 * @param {string|Element|NodeList|jQuery|Object[]} elements
 *   A collection, or group definitions containing elements and options.
 * @param {Object} options
 *   Options used for a single collection: byRow, property, target, or remove.
 * @param {Element|Document|jQuery} context
 *   Default context used when elements is a selector.
 *
 * @return {jQuery|jQuery[]}
 *   One matched collection, or an array of matched collections for a group list.
 */
export const matchHeight = (elements, options = {}, context = document) => {
  const isGroupList = Array.isArray(elements) && elements.every(group => (
    group && Object.prototype.hasOwnProperty.call(group, 'elements')
  ));

  if (isGroupList) {
    return elements.map(group => applyMatchHeight(
      group.elements,
      group.options || {},
      group.context || context
    ));
  }

  return applyMatchHeight(elements, options, context);
};

export default matchHeight;
